import { render, staticRenderFns } from "./CutsSong.vue?vue&type=template&id=2a93d396"
import script from "./CutsSong.vue?vue&type=script&lang=js"
export * from "./CutsSong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports